import Tabs from "./Tabs";
import Tab from "./Tabs";

export { Tabs, Tab };

export default Tabs;
